/**
 * Handles stale chunk detection after deployments.
 * Shows a user-friendly banner when the app version is outdated.
 */

function showNewVersionBanner() {
  // Prevent showing multiple banners
  if (document.getElementById('new-version-banner')) return;

  const banner = document.createElement('div');
  banner.id = 'new-version-banner';
  banner.innerHTML = `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background: linear-gradient(135deg, #f59e0b, #d97706);
      color: white;
      padding: 12px 20px;
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      font-family: system-ui, -apple-system, sans-serif;
      font-size: 14px;
      font-weight: 500;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      direction: rtl;
    ">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>
        <path d="M12 8v4"/>
        <path d="M12 16h.01"/>
      </svg>
      <span>גרסה חדשה זמינה!</span>
      <button id="refresh-btn" style="
        background: white;
        color: #d97706;
        border: none;
        padding: 8px 16px;
        border-radius: 6px;
        font-weight: 600;
        cursor: pointer;
        font-size: 13px;
      ">
        רענן עכשיו
      </button>
    </div>
  `;
  document.body.appendChild(banner);

  document.getElementById('refresh-btn')?.addEventListener('click', async () => {
    if ('caches' in window) {
      const names = await caches.keys();
      await Promise.all(names.map((name) => caches.delete(name)));
    }
    window.location.reload();
  });
}

function isChunkError(message: string): boolean {
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes('MIME type') ||
    message.includes('Importing a module script failed')
  );
}

/**
 * Registers global error handlers to detect stale chunks after deployment.
 * Call this once at app startup.
 */
export function registerVersionCheck() {
  // Handle script loading errors
  window.addEventListener(
    'error',
    (event) => {
      if (
        event.target instanceof HTMLScriptElement ||
        (event.message && isChunkError(event.message))
      ) {
        console.warn('Detected stale chunk - new version available');
        showNewVersionBanner();
      }
    },
    true
  );

  // Handle dynamic import failures
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason?.message || String(event.reason || '');
    if (isChunkError(reason)) {
      console.warn('Detected stale chunk in dynamic import - new version available');
      event.preventDefault();
      showNewVersionBanner();
    }
  });
}
